/**
 * This utility method will convert amount of cents to dollars
 * and returns amount of dollars
 *
 * @param {number} amountInCents
 * @return {number}
 */
function convertCentsToDollars(amountInCents) {
  const amountParsed = Number(amountInCents);
  if (Number.isNaN(amountParsed)) {
    throw new Error('Not a number passed to function');
  }
  return amountParsed / 100;
}

/**
 * This utility method will convert amount of dollars to cents
 * and returns amount of cents
 *
 * @param {number} amountInDollars
 * @return {number}
 */
function convertDollarsToCents(amountInDollars) {
  const amountParsed = Number(amountInDollars);
  if (Number.isNaN(amountParsed)) {
    throw new Error('Not a number passed to function');
  }
  return Math.round(amountParsed * 100);
}

function formatMoneyNumericPart(num = 0) {
  if (typeof num === 'number') return Number(num).toFixed(2);
  return '0.00';
}

function formatMoney(num = 0) {
  const numericPart = formatMoneyNumericPart(num);
  const positiveNumericPart = Math.abs(numericPart);
  return `${numericPart >= 0 ? '' : '-'}$${positiveNumericPart}`;
}

export { convertCentsToDollars, convertDollarsToCents, formatMoneyNumericPart, formatMoney };
